"use client";
import { Newsletter } from "@/api/newsletter";
import { Button, Form, Input, Typography } from "antd";
import React, { useState } from "react";
import Loader from "../loader";
import { useNotification } from "@/app/hooks/useNotification";

type FieldType = {
  email: string;
};

const MembershipForm = () => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const { Title } = Typography;
  const { openNotification } = useNotification();

  const onFinish = async (values: FieldType) => {
    setIsLoading(true);
    try {
      await Newsletter({
        email: values.email,
      });
      openNotification({
        type: "success",
        message: "ایمیل با موفقیت ثبت گردید !",
      });
      form.resetFields();
    } catch (err) {
      openNotification({
        type: "error",
        message: "لطفا مجدد تلاش کنید.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Form
        form={form}
        name="membershipForm"
        layout="vertical"
        initialValues={{ remember: true }}
        onFinish={onFinish}
        autoComplete="off"
        className="w-full"
      >
        <div className="flex flex-col w-full  max-w-[28rem] gap-2 lg:gap-4 items-start relative">
          <Form.Item<FieldType>
            label={
              <Title level={3} className="H3 whiteColor-text">
                عضویت در خبرنامه
              </Title>
            }
            name="email"
            className="pb-0 !mb-0 w-full max-w-[28rem]"
            rules={[
              {
                required: true,
                message: "لطفا ایمیل خود را وارد نمایید."
              },
              {
                type: 'email',
                message: "ایمیل وارد شده معتبر نیست!"
              },
            ]}
          >
            <Input className="h-12" placeholder="example@mail.com" />
          </Form.Item>
          <Form.Item
            label={null}
            className="flex justify-end h-8 !min-h-8 !mb-0 absolute !pe-2 !pt-10 inset-0"
          >
            <Button
              type="primary"
              htmlType="submit"
              className="w-16 h-7 !text-sm !rounded-md flex items-center justify-center !font-semibold"
            >
              {isLoading ? <Loader /> : "عضویت"}
            </Button>
          </Form.Item>
        </div>
      </Form>
    </>
  );
};

export default MembershipForm;
